module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GWD6fo/tc-custom/9781488066788.jpg?1722625963514",
      "alt": "This image is the cover for the book Best Man and the Bridesmaid"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Best Man and the Bridesmaid\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("At a glamorous resort wedding, two doctors discover an undeniable attraction—just as they are needed most—in this international romance.")]), _c('br'), _c('br'), _vm._v("Dr. Andrea knows it’s a cliché for the bridesmaid to fall for the best man. But when Cal arrives in the Italian Alps for her best friend’s wedding, he stirs desires that Andrea hasn’t felt in years. When a series of disasters threatens the ceremony, Andrea realizes Cal is the only one who can help her save the day, even if it means risking her heart in the process . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Annie Claydon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cursed with a poor sense of direction and a propensity to read, Annie Claydon spent much of her childhood lost in books. A degree in English Literature followed by a career in computing didn’t lead directly to her perfect job—writing romance for Mills & Boon—but she has no regrets in taking the scenic route. She lives in London: a city where getting lost can be a joy."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0